import React from 'react'
import './TaskPlayButton.scss'

interface TaskPlayButtonProps {
  onClick?: () => void
  size?: number
  variant?: 'default' | 'expanded'
}

export const TaskPlayButton: React.FC<TaskPlayButtonProps> = ({ onClick, size = 24, variant = 'default' }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick?.()
  }

  if (variant === 'expanded') {
    return (
      <button
        type="button"
        className="task-play-button task-play-button--expanded"
        onClick={handleClick}
        onDoubleClick={(e) => e.stopPropagation()}
      >
        <svg width={size} height={size} viewBox="0 0 28 28" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 0C6.27 0 0 6.27 0 14C0 21.73 6.27 28 14 28C21.73 28 28 21.73 28 14C28 6.27 21.73 0 14 0ZM10.59 7.93C10.85 7.85 11.2 7.85 11.46 8L20.21 13.37C20.39 13.53 20.56 13.76 20.56 13.99C20.56 14.22 20.48 14.45 20.21 14.6L11.46 19.97L11.46 19.97C11.29 20.05 11.11 20.13 10.94 20.13C10.76 20.13 10.68 20.13 10.5 20.05C10.24 19.89 10.06 19.66 10.06 19.36V8.62C10.06 8.31 10.24 8.08 10.59 7.93Z"
            fill="currentColor"
          />
        </svg>
      </button>
    )
  }

  return (
    <button
      type="button"
      className="task-play-button"
      onClick={handleClick}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <svg className="task-play-button__default" width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.95 7.04C9.18 6.98 9.47 6.98 9.7 7.11L17.2 11.71C17.35 11.84 17.5 12.04 17.5 12.24C17.5 12.44 17.43 12.63 17.2 12.76L9.7 17.37C9.55 17.43 9.4 17.5 9.25 17.5C9.1 17.5 9.03 17.5 8.88 17.43C8.65 17.3 8.5 17.11 8.5 16.84V7.64C8.5 7.37 8.65 7.17 8.95 7.04Z"
          fill="var(--space-600)"
        />
      </svg>
      <svg className="task-play-button__hover" width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0ZM9.07 6.79C9.3 6.73 9.6 6.73 9.82 6.86L17.32 11.46C17.48 11.59 17.63 11.79 17.63 11.99C17.63 12.19 17.55 12.38 17.32 12.51L9.82 17.12C9.68 17.18 9.53 17.25 9.38 17.25C9.22 17.25 9.15 17.25 9 17.18C8.78 17.05 8.63 16.86 8.63 16.59V7.39C8.63 7.12 8.78 6.92 9.07 6.79Z"
          fill="var(--space-900)"
        />
      </svg>
    </button>
  )
}
